var _namedview, _g, _g2, _g3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoubleSidewallTemplate = function SvgDoubleSidewallTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "288.0mm",
    height: "288.0mm",
    viewBox: "35.0 35.0 288.0 288.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 229,
    y1: 134,
    y2: 134,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 225,
    y1: 134,
    y2: 133,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 225,
    y1: 134,
    y2: 135,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 133,
    y1: 134,
    y2: 133,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 133,
    y1: 134,
    y2: 135,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 178.82254,
    y: 139.76619,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 122.35072,
    y1: 129.43146,
    y2: 229.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 121.35072,
    y1: 129.43146,
    y2: 133.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 123.35072,
    y1: 129.43146,
    y2: 133.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 121.35072,
    y1: 229.43146,
    y2: 225.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 123.35072,
    y1: 229.43146,
    y2: 225.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -181.43144,
    y: 127.35072,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, "\n            Depth\n        "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 134,
    y1: 89,
    y2: 129,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 133,
    y1: 89,
    y2: 93,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 135,
    y1: 89,
    y2: 93,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 133,
    y1: 129,
    y2: 125,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 135,
    y1: 129,
    y2: 125,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 139,
    y: 111,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90,139,111)"
  }, "\n            Height\n        "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 229,
    y1: 129,
    y2: 129,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 229,
    y1: 129,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 229,
    y1: 229,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 129,
    y1: 129,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 129,
    y1: 90,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 129,
    y1: 89,
    y2: 90,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 229,
    y1: 90,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 229,
    y1: 89,
    y2: 90,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 89,
    y2: 89,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 130,
    y1: 50,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 228,
    y1: 50,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 50,
    y2: 50,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 140,
    y1: 50,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 218,
    y1: 50,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 218,
    y1: 40,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 229,
    y1: 229,
    y2: 268,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 229,
    y1: 269,
    y2: 268,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 129,
    y1: 229,
    y2: 268,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 130,
    y1: 268,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 269,
    y2: 269,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 228,
    y1: 269,
    y2: 308,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 130,
    y1: 269,
    y2: 308,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 308,
    y2: 308,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 218,
    x2: 228,
    y1: 318,
    y2: 308,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 140,
    y1: 308,
    y2: 318,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 218,
    y1: 318,
    y2: 318,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 129,
    y1: 229,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 90,
    y1: 228,
    y2: 229,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 129,
    y1: 129,
    y2: 129,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 90,
    y1: 130,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 89,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 89,
    y1: 228,
    y2: 228,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 89,
    y1: 130,
    y2: 130,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 50,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 40,
    y1: 228,
    y2: 218,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 40,
    y1: 130,
    y2: 140,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 40,
    y1: 218,
    y2: 140,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 90,
    y1: 89,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 128,
    y1: 89,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    x2: 129,
    y1: 89,
    y2: 90,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 90,
    y1: 229,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 128,
    y1: 269,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 128,
    y1: 268,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 268,
    y1: 129,
    y2: 129,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 269,
    y1: 129,
    y2: 130,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 268,
    y1: 229,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 268,
    y1: 228,
    y2: 229,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 269,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 308,
    y1: 130,
    y2: 130,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 308,
    y1: 228,
    y2: 228,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    x2: 308,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    x2: 318,
    y1: 130,
    y2: 140,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 318,
    x2: 308,
    y1: 218,
    y2: 228,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 318,
    x2: 318,
    y1: 140,
    y2: 218,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 268,
    y1: 89,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    x2: 268,
    y1: 89,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 230,
    y1: 90,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 268,
    y1: 229,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    x2: 268,
    y1: 269,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 230,
    y1: 268,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleSidewallTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-sidewall-template.b8da08f7.svg";
export { ForwardRef as ReactComponent };